import React from 'react';
import { useTranslation } from 'react-i18next';
import { BestEnjoy1, BestEnjoy2, BestEnjoy3, BestEnjoyDesc, BestEnjoyHeading } from '../../../Constants';
import EnjoyRiseImg1 from '../../../assets/enjoy-riise-1.webp';
import EnjoyRiseImg2 from '../../../assets/enjoy-riise-2.webp';
import EnjoyRiseImg3 from '../../../assets/enjoy-riise-3.webp';
import myVideo from '../../../assets/how-to-take.mp4';

const HowToEnjoy = ({ isProductPage, className }) => {
  const { t } = useTranslation();

  // const DATA = [
  //   {
  //     desc: t(BestEnjoy1),
  //     img: EnjoyRiseImg1,
  //   },
  //   {
  //     desc: t(BestEnjoy2),
  //     img: EnjoyRiseImg2,
  //   },
  //   {
  //     desc: t(BestEnjoy3),
  //     img: EnjoyRiseImg3,
  //   },
  // ];
  return (
    <div className="t-flex t-flex-col t-gap-4">
      <div className="t-flex t-flex-col">
        <h2 className="t-text-center !t-m-0 t-font-serif t-font-normal t-text-navy">{t(BestEnjoyHeading)}</h2>
        <p className="!t-m-0 t-text-center t-font-sans t-text-[15px] t-text-navy/70">{t(BestEnjoyDesc)}</p>
      </div>
      <video
        src={myVideo}
        autoPlay
        muted
        loop
        playsInline
        controls={false} // remove this if you don't want controls
        className={`t-w-full t-object-cover t-rounded-xl ${className}`}
      />
      {/* <div className="t-flex t-items-stretch t-w-full t-gap-4">
        {DATA.map((item, i) => (
          <div
            className="t-flex t-flex-col t-items-center t-gap-2"
            key={"how-t-enjoy-" + i}
          >
            <p className="t-m-0 t-h-10 t-w-10 t-bg-secondary t-text-white t-rounded-full t-flex t-items-center t-justify-center">
              {i + 1}
            </p>
            <p className="t-m-0 t-text-center t-text-xs">{item.desc}</p>
            <img src={item.img} alt="" className="t-mt-auto" />
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default HowToEnjoy;
